import { useMutation, useQueryClient } from '@tanstack/react-query'

import { transferServices } from '../transferServices'
import { SavingGoalByIDParams } from '../transferTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

interface UseDeleteSavingGoalOptions {
  onSuccess?: () => void
  onError?: (error: { errorMessage?: string; code?: string }) => void
}

export const useDeleteSavingGoal = (options?: UseDeleteSavingGoalOptions) => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, Error, SavingGoalByIDParams>({
    mutationFn: transferServices.deleteSavingGoal,
    onSuccess: () => {
      // Invalidate goals list to refetch
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SAVING_GOALS],
      })
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SAVING_GOAL],
      })

      if (options?.onSuccess) {
        options.onSuccess()
      }
    },
    onError: (error) => {
      if (options?.onError) {
        options.onError({
          errorMessage: error.message || 'Something went wrong',
          code: 'UNKNOWN_ERROR',
        })
      }
    },
  })

  return {
    ...mutation,
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
  }
}
